/* (c) Copyright 2020 Pivotal Software, Inc. All Rights Reserved. */
"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _puiReactAnimation = _interopRequireDefault(require("pui-react-animation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(ParentClass) {
  var _temp;

  return _temp = /*#__PURE__*/function (_ParentClass) {
    _inheritsLoose(Animation, _ParentClass);

    function Animation() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _ParentClass.call.apply(_ParentClass, [this].concat(args)) || this;

      _defineProperty(_assertThisInitialized(_this), "shouldAnimate", _puiReactAnimation["default"].shouldAnimate);

      _defineProperty(_assertThisInitialized(_this), "animate", _puiReactAnimation["default"].animate);

      return _this;
    }

    var _proto = Animation.prototype;

    _proto.componentWillUnmount = function componentWillUnmount() {
      if (_ParentClass.prototype.componentWillUnmount) _ParentClass.prototype.componentWillUnmount.call(this);

      _puiReactAnimation["default"].componentWillUnmount.call(this);
    };

    return Animation;
  }(ParentClass), _temp;
};

exports["default"] = _default;